export default __webpack_public_path__ + "static/media/comingSoonEn.ab22abcf.png";